"use strict";

import Page from "./TicketRefund.jsx";

export const auth = true;
export const title = "i18n:ticketRefund.refundParking";
export const Component = Page;
